(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Cotter", [], factory);
	else if(typeof exports === 'object')
		exports["Cotter"] = factory();
	else
		root["Cotter"] = factory();
})(window, function() {
return 